import * as system from 'durandal/system';
import * as ko from 'knockout';

import { FileStorageDownloadLinkViewModel } from '@/features/file-attachments';
import * as userService from '@/legacy/services/user';
import * as xhrService from '@/legacy/services/xhrService';
import * as plootoUtils from '@/legacy/utils/plooto';

const API_PREFIX = 'v1';

interface PopupParameters {
  location: number;
  width: number;
  height: number;
  left?: number;
  top?: number;
}

export class ContactPaymentViewModel {
  public id: string;

  public memo: string;

  public amount: number;

  public paymentStatusValue: number;

  public creditDate: string;

  public estimatedCompletionDate: string;

  public hasAttachments: boolean;

  public attachments: ContactPaymentAttachments;
}
export class ContactPaymentCollectionViewModel {
  public payments: Array<ContactPaymentViewModel>;

  public debitCompanyName: string;

  public creditContactName: string;

  public contactKey: string;
}
export class ContactPaymentAttachments {
  public attachmentStatus = ko.observable<string>('loadRequired');

  public attachments = ko.observableArray<any>([]);
}

export class EmailMoneyTransferService {
  private userService: userService.UserService;

  constructor() {
    this.userService = userService.Instance;
  }

  public GetByEmailKey(emailKey: string, from: string, to: string, page: number) {
    const dataPromiseWithXhr = new xhrService.PromiseWithXhr<ContactPaymentCollectionViewModel>();
    dataPromiseWithXhr.getXhr = () =>
      this.userService.AuthorizedGetFromUri(
        `${
          import.meta.env.APP_URLS_API_URL
        }/${API_PREFIX}/contact/${emailKey}/payments?from=${from}&to=${to}&page=${page}`
      ) as JQueryXHR;
    dataPromiseWithXhr.dataProcessCallback = (data: ContactPaymentCollectionViewModel) => data;

    xhrService.Instance.initiatePromiseWithXhr(dataPromiseWithXhr); // handles both .errors and logout errors

    return dataPromiseWithXhr;
  }

  public GetPaymentAttachmentsForContact(
    emailKey: string,
    paymentId: string
  ): JQueryPromise<Array<any>> {
    return system
      .defer<Array<any>>((dfd) => {
        this.userService
          .AuthorizedGet(
            `${
              import.meta.env.APP_URLS_API_URL
            }/${API_PREFIX}/contact/${emailKey}/payments/${paymentId}/attachments`
          )
          .done((payments) => {
            if (plootoUtils.IsNullOrUndefined(payments) || payments.error === true) {
              dfd.reject(payments);
              return;
            }
            dfd.resolve(payments);
          })
          .fail(() => {
            dfd.reject();
          });
      })
      .promise();
  }

  public generateFileStorageDownloadLink(
    emailKey: string,
    paymentId: string,
    companyFileStorageFileId: string
  ): JQueryPromise<FileStorageDownloadLinkViewModel> {
    return system
      .defer<FileStorageDownloadLinkViewModel>((dfd) => {
        this.userService
          .AuthorizedGetFromUri(
            `${
              import.meta.env.APP_URLS_API_URL
            }/${API_PREFIX}/contact/${emailKey}/payments/${paymentId}/fileStorage/actions/generateDownloadLink`,
            { companyFileStorageFileId }
          )
          .done((payments) => {
            if (plootoUtils.IsNullOrUndefined(payments) || payments.error === true) {
              dfd.reject(payments);
              return;
            }
            dfd.resolve(payments);
          })
          .fail(() => {
            dfd.reject();
          });
      })
      .promise();
  }

  public openWindow(url: string) {
    return system
      .defer((dfd) => {
        // default parameter values
        const popupHeight = 650;
        const popupWidth = 800;
        const popupCentered = true;
        // default parameters
        const parameters: PopupParameters = {
          location: 1,
          width: popupWidth,
          height: popupHeight,
        };
        // center pop-up if needed
        if (popupCentered) {
          parameters.left = (window.screen.width - popupWidth) / 2;
          parameters.top = (window.screen.height - popupHeight) / 2;
        }
        // flatten all parameters into a string
        const features = $.map(parameters, (value, name) => `${name}=${value}`).join(',');

        // open pop-up without URL first to ensure that pop-up blocker wouldn't prevent it after our delay
        const popup = window.open('', '', features);
        if (popup.document) {
          popup.document.write(
            '<html><head><title>Connecting...</title></head><body></body></html>'
          );
        }

        popup.location.href = url;
      })
      .promise();
  }
}

export const Instance = new EmailMoneyTransferService();
